<template>
  <b-table
    :items="items"
    :fields="fields"
    responsive="sm"
    :hover="true"
    striped
  >
    <template v-slot:cell(x)="{ item }">
      {{ formatDatetime(item.x) }}
    </template>
    <template v-slot:cell(y)="{ item }">
      {{ item.y }}{{ dataset.unit }}
    </template>
  </b-table>
</template>

<script>
import moment from 'moment';

export default {
  name: 'LogTable',
  props: {
    dataset: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'x',
          sortable: true,
          label: this.$_.capitalize(this.$t('datetime')),
        },
        {
          key: 'y',
          label: this.$_.capitalize(this.$t('value')),
        },
      ],
    };
  },
  computed: {
    items() {
      return this.dataset.data;
    },
  },
  methods: {
    formatDatetime(value) {
      return moment(value).format('LLL');
    },
  },
};

</script>

<style scoped>

</style>
